import React from 'react';
import {IWorkFlowStatus} from '@shared/services/service-mappers/WorkflowMapper';
import TicketActivityItem, {
  ITicketingSystemTicketActivityItemProps
} from '../TicketActivityItem/TicketActivityItem';
import './TicketAllActivity.scss';

interface ITicketAllActivityProps {
  clinicUsersList: any[];
  statuses: IWorkFlowStatus[];
  selectedDataList: {
    data: any[];
    isLoading: boolean;
  };
  renderTicketActivityItemContent?: ITicketingSystemTicketActivityItemProps['renderTicketActivityItemContent'];
}

const TicketAllActivity = (props: ITicketAllActivityProps): JSX.Element => {
  const {
    clinicUsersList,
    statuses,
    renderTicketActivityItemContent,
    selectedDataList
  } = props;
  return (
    <section className="ticketing-system-ticket-all-activity-wrapper">
      <div className="all-activity-wrapper">
        {selectedDataList.data.map(item => (
          <TicketActivityItem
            statuses={statuses}
            allUsers={clinicUsersList}
            renderTicketActivityItemContent={renderTicketActivityItemContent}
            key={item.id}
            item={item}
            showActivityType
          />
        ))}
      </div>
    </section>
  );
};

export default TicketAllActivity;
